import React, { Component } from 'react';
import RequestSheet from './RequestSheet';
import AnnualBillingAnalysis from './AnnualBillingAnalysis';
import AnnualPaymentCollectionAnalysis from './AnnualPaymentCollectionAnalysis';
import { genModules, genSubAuth } from '../constants';

class RequestAndReturnedSheet extends Component {
    constructor(props) {
        super(props);
        const { auth } = props;
        const modules = [{
            key: 'requestSheet',
            Content: RequestSheet,
        }, {
            key: 'annualBillingAnalysis',
            Content: AnnualBillingAnalysis,
        }, {
            key: 'annualPaymentCollectionAnalysis',
            Content: AnnualPaymentCollectionAnalysis,
        }
        ];

        this.modules = genModules(modules, auth);
    }

    render() {
        const { auth } = this.props;
        const modules = this.modules.map(item => {
            const { key, Content } = item;
            return <Content key={key} auth={genSubAuth(auth, key)} />;
        });
        return (
            <div className="pane">
                {modules}
            </div>
        );
    }
}

export default RequestAndReturnedSheet;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/index.js